import { Trans, useTranslation } from 'react-i18next';

import { useRefreshPeppol, useUser } from '~/api/user';
import { Button, Dialog, Text } from '~/components';
import { statusColorThemes } from '~/styles/themes.css';
import { clsx } from '~/styles/utils';
import { toast } from '~/utils/toast';

import type { CompletionTabProps as Props } from './types';

import {
  activePeppolStyle,
  peppolActionsRowStyle,
  peppolDescriptionStyle,
  peppolStatusRowStyle,
  warningTextStyle,
} from '../CompleteAccountDialog.css';

export const PeppolTab = ({ isLastTab, onCompleted }: Props) => {
  const { data: user } = useUser();
  const mutation = useRefreshPeppol();

  const { t } = useTranslation(['common', 'settings']);

  return (
    <>
      {user.peppol.id !== null && (
        <Text className={activePeppolStyle}>
          {t('settings:integrations.peppol.fields.peppolId.label')}: {user.peppol.id}
        </Text>
      )}

      <div className={peppolDescriptionStyle}>
        <Trans
          components={{
            paragraph: <Text />,
            bold: <strong />,
          }}
          i18nKey="settings:accountCompletionModal.peppol.description"
        />
      </div>

      <Dialog.Actions>
        <div className={peppolActionsRowStyle}>
          <div className={peppolStatusRowStyle}>
            {user.peppol.id === null && (
              <Button
                icon="Search"
                loading={mutation.isPending}
                onClick={() => mutation.mutate(undefined, { onError: () => toast.danger({ description: t('common:error') }) })}
                type="button"
              >
                {t('settings:accountCompletionModal.peppol.checkAgain')}
              </Button>
            )}

            {mutation.isSuccess && user.peppol.id === null && (
              <Text className={clsx(warningTextStyle, statusColorThemes.warning)}>
                {t('settings:integrations.peppol.fields.status.options.NotRegistered')}
              </Text>
            )}
          </div>

          <Button disabled={user.peppol.id === null} onClick={onCompleted} type="button">
            {t(`settings:accountCompletionModal.action.${isLastTab ? 'complete' : 'next'}`)}
          </Button>
        </div>
      </Dialog.Actions>
    </>
  );
};
